import React, { useEffect } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Card,
  CardContent,
  Modal,
  IconButton,
  Typography,
  Tooltip,
  Grid,
  TextField,
  Alert, 
  AlertTitle, 
  AlertProps,
  Backdrop,
  CircularProgress,
  MenuItem,
} from "@mui/material";
import { Theme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { uploadReconciliation } from "../../utils/PostAdmin"
import requestMissingContexts, { determineConfig } from "../../utils/GetContext";
import {checkForRole, getAuth} from "../../utils/GetAuth";
import {
  Lock,
  ExpandMore,
  Attachment,
  Publish,
  Help,
  Clear,
 } from '@mui/icons-material';
import { getInconsistentGenerate, getInconsistentReportData } from "src/utils/GetAdmin";
import TableAbstraction from "src/componentUtils/TableAbstraction";
import GetApp from "@mui/icons-material/GetApp";
import { getSalesOfficesAndRoutes } from "src/utils/GetPlanning";
import { useMsal } from "@azure/msal-react";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    accordion: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    card: {
    },
    primary: {
      marginTop: theme.spacing(2),
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    paragraph: {
      padding: theme.spacing(1),
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    paragraphButton: {
      marginLeft: theme.spacing(2),
      minWidth: 160,
    },
    input: {
      paddingLeft: "20px", 
      paddingRight: "20px", 
      width:"350px"
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
    grid: {
      marginLeft: theme.spacing(2),
    },
  })
);
function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
  };
}
interface DeliveryPlant {
  plant: string,
  name: string,
}

export default function AdminReconciliation() {
  const classes = useStyles();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [codes, setCodes] = React.useState<any>();
  
  const [modalStyle] = React.useState(getModalStyle);
  const [alertLevel, setAlertLevel] = React.useState<AlertProps>({severity:"info"});
  const [alertTitle, setAlertTitle] = React.useState<string>();
  const [alertMessage, setAlertMessage] = React.useState<string>();
  const [fileName, setfileName] = React.useState<string>();
  const [openAlertWindow, setOpenAlertWindow] = React.useState(false);
  const handleModalClose = () => {
    setOpenAlertWindow(false);
  }
  
  const enabled = checkForRole(clientId,salesOrg,'vp_admin_bulk');

  const [selectedFile, setSelectedFile] = React.useState<File>();
  const [backdropLoader, setBackdropLoader] = React.useState<boolean>(false);
  const [inconsistentReport,setInconsistentReport]=React.useState<any>([]);
  const [deliveringPlants,setDeliveringPlants]=React.useState<any>([]);
  const [allSalesOrgs,setAllSalesOrgs]=React.useState<any>([]);
  const [newSalesOrg,setNewSalesOrg]=React.useState<any>("");
  const [newPlant,setNewPlant]=React.useState<any>("");
  const { instance, accounts, inProgress } = useMsal();
  const [salesOrgs, setSalesOrgs] = React.useState<any[]>([]);
  const [dbSystemInd, setDbSystemInd] = useLocalStorage("SETTINGS.dbSystemInd", "?");

  useEffect(()=>{
    /**Initial table data */
    try {
      getReports(salesOrg,newPlant);

      setBackdropLoader(true);
      getAuth(instance, accounts).then((v) => {
        setSalesOrgs((v?.salesOrgs)||[]);
        setDbSystemInd((v?.dbSystemInd)||'?');
        requestMissingContexts(["SALESORGS"]).then((v) => {
          setCodes(v);
        })
      });
    } catch (error) {
      setBackdropLoader(false);
    }

  },[]);

  useEffect(()=>{
    try {
      if (newSalesOrg!="") {
        setBackdropLoader(true);
        getSalesOfficesAndRoutes(newSalesOrg.toString()).then((v:any) => {
         // console.log("v",v)
          if (v) {
            const r_so:any[] = v.plants;
            if (r_so) {
              requestMissingContexts(["PLANTS"]).then((ctx) => {
                const contexts:any = ctx;
                //console.log('ctx',ctx)
                var plants: Array<DeliveryPlant> = [];
                for (var i=0; i<r_so.length; i++) {
            
                  const so = r_so[i].plant;
                  const desc = so + ": " + determineConfig(
                    contexts,
                    "PLANTS",
                    so || ""
                  );
                  const deliveryPlant:DeliveryPlant = {plant: so, name: desc};
                  plants.push(deliveryPlant);
                }
                setDeliveringPlants(plants);
                setBackdropLoader(false);
              });
            }
          }else{
            setBackdropLoader(false);
            setDeliveringPlants([]);
            alert('fetching delivering plant not successful')
          }
        });
      }
    } catch (error) {
      setBackdropLoader(false);
      setDeliveringPlants([]);
    }

  },[newSalesOrg])

  const getReports=(salesOrg:any,plant:any)=>{
    setBackdropLoader(true);
    getInconsistentReportData(salesOrg,plant,'Customer').then((result) => {
     // console.log(result?.data?.txInconsistentReport);
      setBackdropLoader(false);
      setInconsistentReport(result?.data?.txInconsistentReport)
    })
  }

  const generateReports=(salesOrg:any)=>{
    setBackdropLoader(true);
    getInconsistentGenerate(salesOrg).then((result) => {
     // console.log(result);
      setBackdropLoader(false);
      getReports(salesOrg,newPlant);
    })
  }

  const handleSalesOrg=(salesOrg:any)=>{
   // console.log("salesOrg",salesOrg);
    setNewSalesOrg(salesOrg);
    setNewPlant("");
  }

  const handleDeliveringPlant=(plant:any)=>{
  //  console.log("plant",plant);
    setNewPlant(plant)
  }
  return ( 
      enabled ? (
    <div className={classes.root}>
     
      {/* <Grid item xs={4} md={4} lg={4} xl={4}>
                      <Button
                        color="primary"
                        variant="contained"
                        className={classes.paragraphButton}
                        onClick={()=>generateReports(salesOrg)}
                      >
                        <GetApp/> Generate Report
                      </Button>
      </Grid> */}
      {/* <Typography
        variant="subtitle1"
        className={classes.paragraphAct}
        paragraph
      >
        This page allows you to fetch the inconsistent report data of VendSmart. 
        <strong>Use this tool with caution as you will need to manually delete once created. </strong> 
      </Typography>
      <Grid container spacing={2} className={classes.primary}>
        <>
          <Grid item xs={12} md={12} xl={12}>
            <Accordion className={classes.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography variant="h5" className={classes.paragraph}>
                  <Help /> How to Use
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                
                <Card className={classes.card}>
                  <CardContent>
                  <Typography
                    variant="subtitle1"
                    className={classes.paragraphAct}
                    paragraph
                  >
                     Upload inconsistency reconciliation sap file of VendSmart. 
                  </Typography>
                  </CardContent>
                </Card>
              </AccordionDetails>
            </Accordion>
          </Grid>
        </>

        <>
          <Grid item xs={12} md={12} xl={12}>
            <Card className={classes.card}>
              <CardContent>
                  <Grid className={classes.grid} container spacing={3}>
                  {/* <Grid item xs={4} md={4} lg={4} xl={4}>
                      <TextField
                        fullWidth
                        color="secondary"
                        label="Sales Orgs"
                        value={newSalesOrg || ''}
                        select
                        onChange={(e)=>handleSalesOrg(e.target.value)}
                        // disabled={props.data.isLoading}
                        >
                        {salesOrgs.map((option: any) => (
                        // <MenuItem key={option.code} value={option.code}>
                        //   {`${option.code}: ${option.text}`}
                        // </MenuItem>
                          <MenuItem key={option} value={option} >
                            {`${option}: ${determineConfig(codes, "SALESORGS",option)}`}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={4} md={4} lg={4} xl={4}>
                      <TextField
                        fullWidth
                        color="secondary"
                        label="Delivery Plants"
                        value={newPlant || ''}
                        select
                        onChange={(e)=>handleDeliveringPlant(e.target.value)}
                        // disabled={props.data.isLoading}
                        >
                        {deliveringPlants.map((option: any) => (
                        <MenuItem key={option.plant} value={option.plant}>
                          {option.name}
                        </MenuItem>
                        ))}
                      </TextField>
                    </Grid> 
                    <Grid item xs={4} md={4} lg={4} xl={4}>
                      <Button
                        color="primary"
                        variant="contained"
                        className={classes.paragraphButton}
                        // onClick={()=>getReports(newSalesOrg,newPlant)}
                      >
                        <GetApp/> Generate Report
                      </Button>
                    </Grid>
                  </Grid>
                </CardContent>
            </Card>
          </Grid>
        </>

        <>
          <Grid item xs={12} md={12} xl={12}>
              <Card className={classes.card}>
            
              </Card>
          </Grid>
        </>
      </Grid> */}

      <TableAbstraction
                  settingsKey="ADM_BN"
                  options={{
                    draggableColumns: {
                      enabled: true,
                    },
                    serverSide: false,
                    selectableRows: "none",
                  }}
                  title="Inconsistent Report Data"
                  columns={[
                    {
                      label: "Sales Org",
                      name: "sales_org",
                      options: {
                        searchable: true,
                        filter: false,
                      }
                    },                    {
                      label: "Delivering Plant",
                      name: "delivering_plant",
                      options: {
                        searchable: true,
                        filter: true,
                      }
                    },                    {
                      label: "route",
                      name: "route",
                      options: {
                        searchable: true,
                        filter: true,
                      }
                    },
                    {
                      label: "Customer Number",
                      name: "customer_num",
                      options: {
                        searchable: true,
                        filter: true,
                      },
                    },
                    {
                      label: "Equipment Num",
                      name: "equipment_num",
                      options: {
                        searchable: true,
                        filter: false,
                      },
                    },
                    {
                      label: "Model",
                      name: "model",
                      options: {
                        searchable: true,
                        filter: false,
                      },
                    },
                    {
                      label: "Lodaded Timestamp",
                      name: "lodaded_timestamp",
                      options: {
                        searchable: true,
                        filter: true,
                      },
                    },
                    {
                      label: "Vpt Type",
                      name: "vpt_type",
                      options: {
                        searchable: true,
                        filter: true,
                      },
                    },
                    {
                      label: "Equipment Status",
                      name: "equipmentStatus",
                      options: {
                        searchable: true,
                        filter: true,
                      },
                    },
                    {
                      label: "Settlement Method",
                      name: "settlementMethod",
                      options: {
                        searchable: true,
                        filter: true,
                      },
                    },
                    {
                      label: "Sub Serial Num",
                      name: "sub_serial_num",
                      options: {
                        searchable: true,
                        filter: true,
                      },
                    },
                      {
                      label: "Customer Name",
                      name: "name1",
                      options: {
                        searchable: true,
                     
                        filter: true,
                      },
                    },
                    {
                      label: "Customer Type",
                      name: "cust_type",
                      options: {
                        searchable: true,
                     
                        filter: true,
                      },
                    },
                    {
                      label: "AML",
                      name: "auth_material_list_id",
                      options: {
                        searchable: true,
                     
                        filter: true,
                      },
                    },
                    {
                      label: "EML",
                      name: "auth_material_exclu_list_id",
                      options: {
                        searchable: true,
                     
                        filter: true,
                      },
                    },
                    {
                      label: "Access Day",
                      name: "acces_days",
                      options: {
                        searchable: true,
                     
                        filter: true,
                      },
                    },
                  ]}
                  data={inconsistentReport}
                />

      {/* <Modal
        open={openAlertWindow}
        onClose={handleModalClose}>
        <div style={modalStyle} className={classes.paper} >
              <Alert severity={alertLevel.severity}>
                <AlertTitle>{alertTitle}</AlertTitle>
                {alertMessage}
                <div style={{ paddingRight: "5px", textAlign:"right"}}>
                  <React.Fragment>
                    <Tooltip title={"Close"}>
                        <IconButton onClick={handleModalClose}>
                          <Clear />
                        </IconButton>
                    </Tooltip>
                  </React.Fragment>
                </div>
              </Alert>
        </div>
      </Modal> */}
      <Backdrop sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={backdropLoader}>
        <CircularProgress color="primary" />
      </Backdrop>
    </div>
    ) : (
          <Alert severity="error">
            <AlertTitle><Lock/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Admin Reconciliation</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
  );
}